import { render, staticRenderFns } from "./train.vue?vue&type=template&id=8dd6f654&scoped=true&"
import script from "./train.vue?vue&type=script&lang=js&"
export * from "./train.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd6f654",
  null
  
)

export default component.exports